export default {
  badge: "Bricka",
  close: "Stäng",
  dataIterator: {
    noResultsText: "Inga poster funna",
    loadingText: "Laddar data...",
  },
  dataTable: {
    itemsPerPageText: "Rader per sida:",
    ariaLabel: {
      sortDescending: "Sorterat fallande.",
      sortAscending: "Sorterat stigande.",
      sortNone: "Osorterat.",
      activateNone: "Aktivera för att ta bort sortering.",
      activateDescending: "Aktivera för sortering fallande.",
      activateAscending: "Aktivera för sortering stigande.",
    },
    sortBy: "Sortera efter",
  },
  dataFooter: {
    itemsPerPageText: "Objekt per sida:",
    itemsPerPageAll: "Alla",
    nextPage: "Nästa sida",
    prevPage: "Föregående sida",
    firstPage: "Första sidan",
    lastPage: "Sista sidan",
    pageText: "{0}-{1} av {2}",
  },
  datePicker: {
    itemsSelected: "{0} markerade",
    nextMonthAriaLabel: "Nästa månad",
    nextYearAriaLabel: "Nästa år",
    prevMonthAriaLabel: "Förra månaden",
    prevYearAriaLabel: "Förra året",
  },
  noDataText: "Ingen data tillgänglig",
  carousel: {
    prev: "Föregående vy",
    next: "Nästa vy",
    ariaLabel: {
      delimiter: "Carousel slide {0} of {1}",
    },
  },
  calendar: {
    moreEvents: "{0} fler",
  },
  fileInput: {
    counter: "{0} filer",
    counterSize: "{0} filer (av {1} totalt)",
  },
  timePicker: {
    am: "AM",
    pm: "PM",
  },
  pagination: {
    ariaLabel: {
      wrapper: "Pagination Navigation",
      next: "Nästa sida",
      previous: "Föregående sida",
      page: "Gå till sidan {0}",
      currentPage: "Aktuell sida, sida {0}",
    },
  },
  crm: {
    default: {
      button: {
        confirm: "Bekräfta",
        cancel: "Avbryt",
      },
    },
    contact: {
      address: {
        address: "Gatuadress/boxadress",
        postalCode: "Postnummer",
        city: "Ort",
        region: "Region/stat",
        country: "Land",
      },
    },
    content: {
      sign: {
        label: "Signera",
        title: "E-signering",
        parties: {
          title: "Parter",
        },
        role: {
          signatory: "Undertecknare",
          reviewer: "Granskare",
        },
        status: {
          pending: "Väntar på underskrift",
          signed: "Har signerat dokumentet",
        },
        comments: {
          label: "Kommentar",
          placeholder: "Kommentera",
          thanks: "Tack för din kommentar",
        },
        review: {
          label: "Granska dokument",
        },
        confirm: {
          label: "Bekräfta",
          text1: "Jag bekräftar härmed att jag är {0}",
          text2: " och företräder {0}",
          text3:
            ". Jag bekräftar också att jag äger rätt att underteckna det aktuella dokumentet.",
          done: "Tack! Du har nu signerat dokumentet",
        },
        drawer: {
          open: "Visa parter",
          close: "Stäng panel",
        },
      },
    },
  },
  inspectech: {
    order: {
      form: {
        mandatory: "*) Obligatorisk information",
        orderType: {
          help: "Ange vad du vill göra",
          label: "Ärende",
        },
        inspectionTypes: {
          help: "Ange vilken tjänst du är intresserad av",
          label: "Jag är intresserad av *",
          required: "Du måste ange vad du vill beställa",
        },
        customer: {
          help: "Uppdragsgivarens kontaktuppgifter",
          label: "Uppdragsgivarens kontaktuppgifter",
          companyName: {
            help: "Företagsnamn",
            label: "Uppdragsgivarens företagsnamn (om relevant)",
          },
          firstName: {
            help: "Uppdragsgivarens förnamn",
            label: "Förnamn *",
          },
          lastName: {
            help: "Uppdragsgivarens efternamn",
            label: "Efternamn *",
          },
          phone: {
            help: "Telefon till uppdragsgivaren",
            label: "Telefon *",
          },
          email: {
            help: "Uppdragsgivarens e-postadress",
            label: "E-post *",
          },
          number: {
            help: "Uppdragsgivarens personnummer (för fakturering)",
            label: "Personnummer",
          },
        },
        broker: {
          help: "Ange kontaktuppgifter till fastighetsmäklare",
          label: "Fastighetsmäklare",
          companyName: {
            help: "Mäklarfirma",
            label: "Namn på mäklarfirman",
          },
          firstName: {
            help: "Mäklarens förnamn",
            label: "Förnamn",
          },
          lastName: {
            help: "Mäklarens efternamn",
            label: "Efternamn",
          },
          phone: {
            help: "Telefon till mäklaren",
            label: "Telefon",
          },
          email: {
            help: "Mäklarens e-postadress",
            label: "E-post",
          },
          number: {
            help: "Mäklarens kundnummer",
            label: "Kundnummer",
          },
        },
        estate: {
          help: "Ange fakta om fastigheten",
          label: "Objekt att besikta",
          copyAddress: "Kopiera namn/adress från uppdragsgivaren",
          owner1: {
            firstName: {
              label: "Ägarens förnamn",
            },
            lastName: {
              label: "Ägarens efternamn",
            },
          },
          owner2: {
            firstName: {
              label: "Ytterligare ägares förnamn",
            },
            lastName: {
              label: "Ytterligare ägares efternamn",
            },
          },
          location: {
            label: "Kommun *",
            required: "Kommun är obligatoriskt",
          },
          number: {
            label: "Fastighetsbeteckning *",
            required: "Fastighetsbeteckning är obligatoriskt",
          },
        },
        date: {
          help: "Ange önskat datum",
          label: "Önskat datum",
          disclaimer:
            "Önskat besiktningsdatum i samband med beställning utgör inte en\n" +
            "garanti för att vi kan utföra uppdraget den dagen. Bokningen,\n" +
            "både datum och tid, bekräftas skriftlig av oss och framgår i\n" +
            "uppdragsbekräftelsen.",
        },
        calendar: {
          link: {
            label: "Titta i stora kalendern",
          },
        },
        privacy: {
          help: "Lagring av personuppgifter",
          label:
            "I enlighet med GDPR samtycker jag att mina personuppgifter sparas i samband med den här beställningen/offertförfrågan.",
          required:
            "Du måste godkänna lagring av personuppgifter för att kunna beställa!",
          link: "Läs om hur vi behandlar personuppgifter här.",
        },
        submit: {
          help: "Skicka beställningen",
          label: "Skicka",
          success: "Skickar beställning...",
          error: "Beställningen kunde inte skickas!",
        },
      },
      confirm: {
        header: "Tack för din beställning!",
        message:
          "Vi återkommer inom kort med besked om din bokning och uppdragsbekräftelse.",
        website: "Tillbaka till {0}",
      },
      calendar: {
        today: "Idag",
        type: {
          day: "Dag",
          week: "Vecka",
          month: "Månad",
        },
      },
    },
  },
};
